import React, { useState, useEffect, useRef } from 'react';
import './ConsultWithUs.css';

import app from 'new-ui/app';

import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { authenticationApi } from 'components/Authentication/api';
import PropTypes from 'prop-types';
import { CRM_EVENTS } from 'new-ui/constants';
import { INTERCOM_EVENTS } from 'modules/intercom/intercom';
import configs from 'configs';

const { calendly } = configs;

const CALENDLY_EVENTS = {
  EXPLORE_CLINICAL_TRIALS: 'exploring-clinical-trials-with-us',
};

const ConsultWithUs = ({ source }) => {
  const sourceRef = useRef(source);
  const sendIntercomEventRef = useRef(false);
  const user = app.user.info;
  const { email, family_name } = user ?? {};

  const [calendlyUrl, setCalendlyUrl] = useState(false);
  // eslint-disable-next-line
  const [, setTimeLeft] = useState(15 * 60);

  useCalendlyEventListener({
    onEventScheduled: () => {
      sendIntercomEventRef.current = true;
      app.updateUserConfiguration({
        lastConsultWithUs: new Date().toISOString(),
      });
    },
  });

  useEffect(() => {
    let url = `${calendly.calendlySiteUrl}/${calendly.account}/${CALENDLY_EVENTS.EXPLORE_CLINICAL_TRIALS}?hide_gdpr_banner=1`;
    // Pass actual user name, email, phone number in case was provided during authorisation

    if (user) {
      url += `&email=${user.email}`;
      if (user.family_name) url += `&name=${user.family_name}`;
      if (user.phone) url += `&location=${user.phone}`;
    }
    setCalendlyUrl(url);
  }, [user]);

  useEffect(() => {
    const timeoutAction = () => {
      authenticationApi
        .registerUserRequests({
          user: {
            email,
            name: family_name ?? email,
          },
          type: CRM_EVENTS.TRIED_TO_SCHEDULE_A_CALL,
          content: 'The patient tried to schedule a calls',
        }).catch((ex) => console.error(ex));

      authenticationApi.updateIntercomUser({
        data: {
          tags: ['tried_to_schedule_a_call'],
        },
      }).catch((ex) => console.error(ex));
    };

    const interval = setInterval(() => {
      setTimeLeft((timeLeft) => {
        if (timeLeft === 1) {
          clearInterval(interval);
          timeoutAction();
        }
        return timeLeft - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [email, family_name]);

  // onPopupClose
  useEffect(() => () => {
    if (sendIntercomEventRef.current && sourceRef.current) {
      app.intercom.sendEvent(INTERCOM_EVENTS.CONSULT_WITH_US.POPUP_SUCCESS, { source: sourceRef.current });
    }
  }, []);

  return (
    <div className="consult-with-us">
      <div>
        { calendlyUrl ? <InlineWidget url={calendlyUrl} /> : null }
      </div>
    </div>
  );
};

ConsultWithUs.propTypes = {
  source: PropTypes.string,
};

export default ConsultWithUs;
